import React from 'react';
import NotFound from '../features/NotFound/NotFound';

const NotFoundPage = () => (
  <NotFound />
);

export default NotFoundPage;
